<template>
    <div class="">
        <header-layout :fo_config="fo_config" :settingsConfig="settingsConfig"></header-layout>
        <div class="mon-compte">
            <div class="title-compte">
                <div class="container">
                    <h2>Mon compte</h2>
                    <div class="list-overflow">
                        <div class="xx">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                <button class="nav-link" :class="{ active: activeTab === 'rdv' }" @click="toggleTab('rdv')">Mes Rendez-vous</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                <button class="nav-link" :class="{ active: activeTab === 'history' }" @click="toggleTab('history')">Historique</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                <button class="nav-link" :class="{ active: activeTab === 'userInfo' }" @click="toggleTab('userInfo')">Mes informations</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="compte-content">
                    <div class="tab-content" id="myTabContent">
                        <div>
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
            <footer-layout></footer-layout>
        </div>
    </div>
</template>

<script>
    import HeaderLayout from "../SharedComponents/Header.vue";
    import FooterLayout from "../SharedComponents/Footer.vue";
    export default {
        name : 'ProfileLayout',
        components : {HeaderLayout, FooterLayout },
        props : ['fo_config', "settingsConfig", 'activeTab'],
        emits : ['update:activeTab'],
        methods: {
            toggleTab(s) {
                this.$emit('update:activeTab', s)
            }
        }
    }
</script>   